export default __webpack_public_path__ + "static/docs-3a0e0c7ffc13ebd38a0834a44087238f.png";